import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-message',
  template: `
    <div class="activity-message">
      <div style="float: left; margin-right: 10px;">
        <mat-icon>email</mat-icon>
      </div>
      <div>
        <div class="description">
          <strong>
          {{ activity.subType.charAt(0).toUpperCase() + activity.subType.slice(1) }}
          {{ activity.meta.automated ? ' Automated ' : '' }} Message
          {{ activity.meta.attemptNumber ? ' (Email Attempt ' + activity.meta.attemptNumber + ')' : '' }}
          </strong>
          <div class="text">
            <div class="text" *ngIf="activity.subType==='incoming'">
              from <{{ activity.meta.fromEmail }}>
            </div>
            <div class="text" *ngIf="activity.subType==='outgoing'">
              to
                <span *ngFor="let rcpt of activity.meta.recipients">
                  <span *ngIf="rcpt.email !== undefined">
                    <{{ rcpt.email }}>
                  </span>
                  <span *ngIf="rcpt.email === undefined">
                    <{{ rcpt }}>
                  </span>
                </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [],
  standalone: false
})
export class ActivityRowMessageComponent {

  @Input() activity;
}
